import { conRespaldo } from '@/lib/campo/loUltimoQueSeSupo'
import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Lo que esta persona levantó y todavía no está completo.
 *
 * En su propio archivo y no junto al componente: mezclar los dos rompe la
 * recarga en caliente y el linter lo avisa.
 */
export type Levantada = {
  orden_servicio_id: string
  numero: string
  cliente: string
  direccion: string | null
  creado_en: string
  cotizacion_id: string | null
  paso: 'sin_cotizar' | 'borrador' | 'cotizada' | 'esperando' | 'rechazada'
  fotos: number
  /** Por qué la devolvieron. Solo en el paso 'rechazada'. */
  motivo_rechazo: string | null
}

export function useLoQueLevante() {
  return useQuery({
    queryKey: ['lo-que-levante'],
    queryFn: async () =>
      // Lo que levantó en la calle se recuerda: es justo lo que necesita
      // revisar cuando no hay señal, para no levantarlo dos veces.
      conRespaldo<Levantada[]>('lo-que-levante', async () => {
        const { data, error } = await supabase.rpc('fn_lo_que_levante')
        if (error) throw new Error(mensajeDeError(error))
        return (data ?? []) as Levantada[]
      }),
  })
}
